import React, { useState } from 'react';

function OnboardingSlides({ onComplete }) {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      title: "Welcome to Your Family Budget!",
      content: "You've successfully created your account! Thank you so much for signing up! Let's get you started with a quick tour of what you can do.",
      icon: "🎉",
      color: "#ff6b35"
    },
    {
      title: "Track Your Expenses",
      content: "Easily categorize and monitor your spending. Set budgets, track trends, and stay on top of your finances.",
      icon: "📊",
      color: "#4d8afdff"
    },
    {
      title: "Import Expenses Right From Your Bank",
      content: "We don't want to actually connect to your bank but realize it's just easier to automate what we can. Use the import feature to bring in a CSV or Excel file from your Bank account's website!",
      icon: "📃",
      color: "#db48f8ff"
    },
    {
      title: "Create Categories and Manage Budgets",
      content: "Create various categories and set budgets for them to see where your money is going.",
      icon: "💸",
      color: "#1dad59ff"
    },
    {
      title: "Earmark Money for Accounts and Buckets",
      content: "The Accounts page is separate from the rest of the app. Simply list the accounts you want, update the totals as you get paid. You can then create 'buckets' to make sure you've got the money set aside that you need.",
      icon: "🪣",
      color: "#4d8afdff"
    },
    {
      title: "Reach out!",
      content: "Have an idea or feature that you think would be helpful to yourself and others, reach out and let me know! You can always email me at info@duttonbiz.com.",
      icon: "💡",
      color: "#ff6b35"
    },
    {
      title: "All done!",
      content: "I've stalled you long enough, go ahead and get a hold of where your money is going!",
      icon: "🗝️",
      color: "#ff6b35"
    }
  ];

  const nextSlide = () => {
    if (currentSlide < slides.length - 1) {
      setCurrentSlide(currentSlide + 1);
    } else {
      onComplete();
    }
  };

  const prevSlide = () => {
    if (currentSlide > 0) {
      setCurrentSlide(currentSlide - 1);
    }
  };

  const skipToEnd = () => {
    onComplete();
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)',
        borderRadius: '20px',
        padding: '40px',
        maxWidth: '500px',
        width: '90%',
        textAlign: 'center',
        border: '1px solid #404040',
        boxShadow: '0 20px 40px rgba(0, 0, 0, 0.3)'
      }}>
        {/* Progress indicators */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '8px',
          marginBottom: '30px'
        }}>
          {slides.map((_, index) => (
            <div
              key={index}
              style={{
                width: '12px',
                height: '12px',
                borderRadius: '50%',
                backgroundColor: index === currentSlide ? slides[currentSlide].color : '#404040',
                transition: 'all 0.3s ease'
              }}
            />
          ))}
        </div>

        {/* Card content */}
        <div style={{
          minHeight: '300px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center'
        }}>
          <div style={{
            fontSize: '4rem',
            marginBottom: '20px',
            animation: 'slideIn 0.5s ease-out'
          }}>
            {slides[currentSlide].icon}
          </div>

          <h2 style={{
            color: slides[currentSlide].color,
            fontSize: '1.8rem',
            fontWeight: '600',
            marginBottom: '20px',
            animation: 'slideIn 0.5s ease-out 0.1s both'
          }}>
            {slides[currentSlide].title}
          </h2>

          <p style={{
            color: '#e0e0e0',
            fontSize: '1.1rem',
            lineHeight: '1.6',
            marginBottom: '30px',
            animation: 'slideIn 0.5s ease-out 0.2s both'
          }}>
            {slides[currentSlide].content}
          </p>
        </div>

        {/* Navigation buttons */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginTop: '20px'
        }}>
          <button
            onClick={prevSlide}
            disabled={currentSlide === 0}
            style={{
              background: 'transparent',
              border: '1px solid #404040',
              color: currentSlide === 0 ? '#404040' : '#e0e0e0',
              padding: '10px 20px',
              borderRadius: '8px',
              cursor: currentSlide === 0 ? 'not-allowed' : 'pointer',
              fontSize: '14px',
              fontWeight: '500',
              transition: 'all 0.2s ease'
            }}
          >
            Previous
          </button>

          {/* <button
            onClick={skipToEnd}
            style={{
              background: 'transparent',
              border: 'none',
              color: '#888',
              cursor: 'pointer',
              fontSize: '14px',
              textDecoration: 'underline'
            }}
          >
            Skip
          </button> */}

          <button
            onClick={nextSlide}
            style={{
              background: slides[currentSlide].color,
              border: 'none',
              color: 'white',
              padding: '10px 20px',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '600',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-1px)';
              e.target.style.boxShadow = `0 4px 12px ${slides[currentSlide].color}40`;
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = 'none';
            }}
          >
            {currentSlide === slides.length - 1 ? 'Get Started!' : 'Next'}
          </button>
        </div>
      </div>

      <style jsx>{`
        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
}

export default OnboardingSlides;